import { useLogger } from '@btcdirect/shared/src/composables/util/logger';

const { warn } = useLogger();

export const useClipboard = () => {

    const copy = (value: string): void => {
        try {
            navigator.clipboard.writeText(value);
        } catch (exception) {
            warn('Could not copy to clipboard', 'Permission has been denied.');
        }
    };

    return {
        copy
    };
};
